import axiosClient from '../../configs/axios';


class LocationMasterService {
    // Get list 
    async getLocationList(params) {
        try {
            const response = await axiosClient.get(
                `/location/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addLocation(data) {
        try {
            const response = await axiosClient.post('/location/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteLocation(data) {
        try {
            const response = await axiosClient.put(`/location/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new LocationMasterService(); 